// Errors of saving a profile that are about the phone number. They are shown under the phone field,
// not as a pop-up, so the participant sees which field to fix.
const PHONE_ERROR_MESSAGES = {
  INCOMPLETE_PHONE_NUMBER: 'phone_verification.incomplete_phone',
  INVALID_PHONE_NUMBER: 'phone_verification.invalid_phone',
  THIS_PHONE_NUMBER_IS_INVALID: 'phone_verification.invalid_phone',
  THIS_PHONE_NUMBER_IS_ALREADY_IN_USE: 'phone_verification.already_in_use'
}

/**
 * @param {Error} e error of a profile save
 * @param {Function} t the `$t` of the component
 * @returns {string} participant-facing message for the phone field, empty when the error is not about the phone
 */
export function phoneErrorMessage(e, t) {
  const messageKey = PHONE_ERROR_MESSAGES[e?.response?.data?.key]

  return messageKey ? t(messageKey) : ''
}
